import { gql } from "generated-graphql";

export const GET_ACCEPTABLE_FILE_FORMATS_BY_DOCUMENT_TYPE = gql(`
  query GetAcceptableFileFormatsByDocumentType($tenantId: ID!, $facilityId: ID!) {
    getAcceptableFileFormatsByDocumentType(tenantId: $tenantId, facilityId: $facilityId) {
      documentType
      fileFormats
    }
  }
`);

export const GET_UPSERTED_DOCUMENT = gql(`
  query GetDocumentForAddEdit($id: ID!) {
    document(id: $id) {
      id
      title
      description
      storageLink
      documentType
      updatedAt
      createdAt
      authoredAt
      reportId
      documentTags {
        id
        name
        tenantId
        isDisabled
        type
      }
    }
  }
`);
